"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultState = void 0;
var defaultState = {
    locationHost: 'unset_site_domain',
    applicationHost: '',
    targetHost: '',
    testDomain: '',
    isMainPage: false,
    isReady: false,
    enabled: true,
    collector: false,
};
exports.defaultState = defaultState;
var CruxState = __assign({}, defaultState);
exports.default = CruxState;
